import { render } from "./InvitationItem.vue?vue&type=template&id=5b37c35c&scoped=true"
import script from "./InvitationItem.vue?vue&type=script&lang=ts"
export * from "./InvitationItem.vue?vue&type=script&lang=ts"

import "./InvitationItem.vue?vue&type=style&index=0&id=5b37c35c&lang=scss"
import "./InvitationItem.vue?vue&type=style&index=1&id=5b37c35c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b37c35c"

export default script